// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1yZ2f","rootMobile":"styles_rootMobile__EIUaE"};